import React from 'react';
import './InsightsCounterCard.scss';

type AppProps = {
  count?: number;
  subHeading?: string;
  counterColor?: string;
  otherCounter?: number | null;
  otherSubHeading?: string;
  onPress?: () => void;
}

const InsightsCounterCard = ({
  count,
  subHeading,
  counterColor,
  onPress,
  otherSubHeading,
  otherCounter
}: AppProps) => {
  return (
    <div className="card outer-container" onClick={onPress}>
      <div className="card-container">
        <h1 className="counter-style" style={{ background: counterColor }}>{count}</h1>
        <h6 className="counter-sub-header mt-2">{subHeading}</h6>
      </div>
      <div className="divider"></div>
      <div className="card-container other-counter-container">
        <h4 className="other-counter-style" style={{ background: '#dd4433' }}>{otherCounter}</h4>
        <h6 className="counter-sub-header mt-2">{otherSubHeading}</h6>
      </div>
    </div>
  )
};

export default InsightsCounterCard